// extracted by mini-css-extract-plugin
export default {"new-header":"NewHeader_new-header__wNN9-"};